import React from 'react';

import { v4 as uuid } from 'uuid';

import AddControl from 'components/add_control';
import AdditionalEmail from './additional_email';

import type { AdditionalEmail as AdditionalEmailType } from './types';

interface Props {
  additionalEmails: AdditionalEmailType[];
  onChange: (additionalEmails: AdditionalEmailType[]) => void;
}

export default function AdditionalEmails({ additionalEmails, onChange }: Props) {
  function add() {
    onChange([...additionalEmails, { email: '', localId: uuid() }]);
  }

  function replace(updated: AdditionalEmailType) {
    onChange(additionalEmails.map(email => isEqual(email, updated) ? updated : email));
  }

  function remove(removed: AdditionalEmailType) {
    if (removed.id) {
      onChange(additionalEmails.map(email => isEqual(email, removed) ? { ...email, _destroy: true } : email));
    } else {
      onChange(additionalEmails.filter(email => !isEqual(email, removed)));
    }
  }

  return <>
    {additionalEmails.filter(additionalEmail => !additionalEmail._destroy).map(email => (
      <AdditionalEmail
        additionalEmail={email}
        key={email.id || email.localId}
        onChange={replace}
        onDelete={remove}
      />
    ))}

    <AddControl className="mx-4" onClick={add}>
      Add another email
    </AddControl>
  </>;
}

function isEqual(additionalEmail1: AdditionalEmailType, additionalEmail2: AdditionalEmailType) {
  if (additionalEmail1.id && additionalEmail2.id) {
    return additionalEmail1.id === additionalEmail2.id;
  } else {
    return additionalEmail1.localId === additionalEmail2.localId;
  }
}
